import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { City, OrganizationRequest, PaginationModel, State } from 'src/app/models';
import { CommonService, ErxService, ModalWrapperService, RxTransferService, UserService } from 'src/app/services';
import {
  PharmacyData,
  Pharmacy,
  PharmacyDatas,
  Pharmphone
} from "./../../../models/rxTransfer.model";
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonUtil } from 'src/app/utils';
import { MsgConfig } from 'src/app/app.messages';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransferPharmacyComponent } from '../transfer-pharmacy/transfer-pharmacy.component';
import { PatientInfoUtil } from 'src/app/utils/patient-info.util';
import { CommonWarnorconfirmPopupComponent } from '../common-warnorconfirm-popup/common-warnorconfirm-popup.component';
@Component({
  selector: 'app-pharmacy-suggest',
  templateUrl: './pharmacy-suggest.component.html',
  styleUrls: ['./pharmacy-suggest.component.scss']
})
export class PharmacySuggestComponent implements OnInit {
  unsubscribe$: Subject<void> = new Subject();
  private searchSubscription: Subscription;
  @Output() selectedPharm = new EventEmitter();
  @Output() CloseEditPharmacy = new EventEmitter();
  msgConfig = MsgConfig;
  paginationModel: PaginationModel = new PaginationModel();
  PharmacyNames: PharmacyDatas = new PharmacyDatas();
  logPhaId: any;
  PharmacyNamesList: any;
  modelRef: any;
  getPharmNanes: any;
  addPharFG: FormGroup;
  pharmcyDet: PharmacyData = new PharmacyData();
  public citySelected = null;
  rxTransferFG: FormGroup;
  public stateSelected = null;
  SuggestData: any = [];
  public searchResults: any[] = [];
  searchTerm : any = "";
  selectedPharmDeatails : any = "";
  debounceTime = 1000;
  searching = false;
  DataResult: any;
  isedit : boolean;
  newPharId: any;
  addPopUp = false;
  popupSearchTerm: any;
  phamrcySearchModel: any;
  isShowdropdown: boolean = false;
  IsPhamacyMessage: string = "";
  pharmFocus: boolean;
  focusOut: boolean;
  @Input() set ResetThePhramacy(resetThePha: boolean) {
    if(resetThePha)
      this.inputClearedBySearchIcon();
  }
   @Input() set IsEdit(isEdit: boolean) {
    this. isedit = isEdit;
    if(isEdit){
      this.isedit = true;
      if(!this.selectedPharmDeatails?.PharmId || this.selectedPharmDeatails?.PharmId?.trim()?.length === 0){
        this.editPharmacyAddToLocalDb().then();
      } else {
        this.editPharmacyFromLocalDb();
      }
    }
  }
  
  hideFilterForm: boolean;
  faxFG: FormGroup;
  isDisabled:boolean;
  @Input() frmPatHis: any;
  @Input() isFrmPatExternHist : boolean;
  @Input() eRxPharmacyDetails;
  @Input() TransferPharmacyDetails;
  @Input() SourcePharmacyName : any;
  @Input() IsFrom : string;
  @Input() IsFromeRxpage;
  @Input() RxType:any;
  @Input() IsERx;
  @Input() PatientNotFound;
  @Input() frmCmms;
  @Input()
set selectedpharmacyDetails(sp: any){
  if(sp){
    this.selectedPharmDeatails = sp;
  }
}
  searchTerm$ = new Subject<string>();
  @Input()
    set AutoFocus(ti: boolean) {
      this.pharmFocus = false;
      if(ti) {
        this.pharmFocus = true;
      }
    }
  @ViewChild("searchBoxPharmacyType", { static: true }) searchBoxInsType: ElementRef;
  @ViewChild("patExternPhamracySuggest", { static: true }) patExternPhamracySuggest: ElementRef;
   pharmacies = [
    { PharmName: 'Pharmacy One', Fax: '123-456-7890', NPINum: '1111', Phone: '987-654-3210', AddressLine1: '123 Pharmacy St.' },
    { PharmName: 'Pharmacy Two', Fax: '234-567-8901', NPINum: '2222', Phone: '876-543-2109', AddressLine1: '456 Health Ave.' },
    { PharmName: 'Pharmacy Three', Fax: '345-678-9012', NPINum: '3333', Phone: '765-432-1098', AddressLine1: '789 Wellness Rd.' }
  ];
  constructor(public _commonUtil:CommonUtil,
             private _rxSer: RxTransferService,
             private _eRxService: ErxService,
             private _userService: UserService,
             private _modalService: ModalWrapperService,
             private _fb: FormBuilder,
            public  _patientUtil: PatientInfoUtil,
             private _commonServ: CommonService, private _cdr: ChangeDetectorRef) {
              this.addPharFG = this._fb.group({
                TransferPharmacies: this._fb.group(new Pharmacy()),
                phone1: null,
                phone2: null,
                Fax: null,
                Phone: this._fb.array([new Pharmphone()])
            });

              }

  ngOnInit(): void {
    if (localStorage.getItem("RestoreAddrData") && this._commonServ.DecryptData(localStorage.getItem("RestoreAddrData")) && this.frmPatHis && this.frmPatHis["Type"] === "Out") {
      this.DataResult = JSON.parse(this._commonServ.DecryptData(localStorage.getItem("RestoreAddrData")));
      this.hideFilterForm = true;
      if(this.DataResult?.TransferPharmacy?.Fax)
          this.faxFG.patchValue({
              fax: this.DataResult?.TransferPharmacy?.Fax
          });
  }
    if((this.isFrmPatExternHist || this.frmCmms) && this.SourcePharmacyName){
      this.searchTerm = this.SourcePharmacyName;
    }
    if(((this.eRxPharmacyDetails && this.eRxPharmacyDetails?.TargetPharmacyDetails) || ['er','vrf'].includes(this.RxType)) || this.PatientNotFound) {
      this.isDisabled = true;
      this.TransferPharmacyDetails = this.eRxPharmacyDetails?.TargetPharmacyDetails;
      if(this.TransferPharmacyDetails?.hasOwnProperty('isServiceEnabled'))
          this.TransferPharmacyDetails['isServiceEnabled'] = true;
      }
    this.searchSubscription =  this.searchTerm$
    .pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap(term => {
          if (!term) 
           return of([]); // returns an empty result to the subscriber
        else if(term){
          const modelData = this._commonUtil.getOrganizationRequestForPharmSuggest(term);
          return of(modelData).pipe(filter(data => data !== null && data!==undefined)).pipe(
            switchMap((modelData: OrganizationRequest) => this._eRxService.toGetTranferPharListWithServiceAvail(modelData)),
            map((pharmacies: any[]) => {
                this.isShowdropdown = true;
                this.PharmacyNamesList = pharmacies;
                if(!pharmacies.length && this.searchTerm) {
                  const PhUserName = this._userService.getToken("PharmacyName");
                const IsLogged = PhUserName?.toLowerCase().includes(this.searchTerm?.toLowerCase());
                  this.openWarningMessage(IsLogged, this.searchTerm);
                }  
                delete this.searchTerm;
            })
          );
        }
      })
    )
    .subscribe();

    
  }

  ngOnDestroy() {
  // Prevent memory leaks
  this.searchSubscription.unsubscribe();
}

  openWarningMessage(IsLogged, searchValue) {
    if (!this.modelRef) {
      this.modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {
        backdrop: false,
        keyboard: false, windowClass: "large--content"
      });
      this.modelRef.componentInstance.warnMsg = IsLogged ? '<div><b>Pharmacy: </b> <span class="font-bigger text-primary word_break">' +
        searchValue?.toUpperCase() + '</span> is currently logged in.</div>' : '<div><b>Pharmacy: </b> <span class="font-bigger text-primary word_break">' +
        searchValue?.toUpperCase() + '</span> not found. Would you like to add?</div>';
      if (IsLogged)
        this.modelRef.componentInstance.okButton = true;
      else {
        this.modelRef.componentInstance.yesButton = true;
        this.modelRef.componentInstance.noButton = true;
      }
      this.modelRef.componentInstance.IsHeaderText = "Search Pharmacy";
      this.modelRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
        if (resp && !IsLogged) {
          this.openAddPopUp();
        } 
        if (this.modelRef) {
          this.modelRef.close();
          this.modelRef = null;
          this.searchTerm = null;
        }
      });
    }
  }

  onInputBlur() {
  // Delay slightly to allow item click event (if any)
  if((!this.selectedPharmDeatails && !this.frmCmms)) this.focusOut = true;
  setTimeout(() => {
    this.searchTerm$.next('');  // reset observable
          this.isShowdropdown = false;
  }, 500);
}


  inputFormatter = (result: any) => result?.PharmName & result.ServiceLevels ? result.PharmName : this.frmCmms ? result.PharmName : '';  // Display Pharmacy name

  search = (text$: Observable<string>) => {
    return text$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(term => {
         const modelData = this._commonUtil.getOrganizationRequestForPharmSuggest(term);
         return modelData
      }),
      filter(data => data !== null && data!==undefined),
      switchMap((modelData: any) => {
        return this._eRxService.toGetTranferPharListWithServiceAvail(modelData).pipe(
          tap(pharmacies => this.PharmacyNamesList = pharmacies)
        );
      }),
      map((pharmacies: any[]) => pharmacies.length ? pharmacies : [])
    );
  };

onSearchInputChange(term: string) {
  this.searchTerm$.next(term);
}

  reselectPharmacy() {
    this.inputClearedBySearchIcon();
    const pharmacyEle = document.getElementById("pharmacy-search");
    if(pharmacyEle) 
      pharmacyEle.focus();
  }

  selectedPharmacyDetails(pharmacy) {
    this.isShowdropdown = false;
    this.focusOut = false;
    if(this.phamrcySearchModel){
      this.phamrcySearchModel.close();
      this.phamrcySearchModel = null;
    }
    this.searchTerm = (this.isFrmPatExternHist || this.frmCmms) ? pharmacy?.PharmName : null;
    this.selectedPharmDeatails = pharmacy;
     this.searchTerm$.next('');  // reset observable
     this._cdr.detectChanges();
     this.selectedPharm.emit(pharmacy);
  }
  inputClearedBySearchIcon() {
    this.searchTerm = "";
    this.isShowdropdown = false;
    this.selectedPharmDeatails = null;
    this.focusOut = true;
    this.pharmFocus = false;
     setTimeout(() => {
      this.pharmFocus = true;
    },0);
    this.selectedPharm.emit(this.selectedPharmDeatails);
  }

  enteredValue(event) {
      this.searchTerm$.next(this.searchTerm);
  }

  triggerPharmacySearch(term: string) {
    const trimmedTerm = term?.trim();
    if (this.isFrmPatExternHist && trimmedTerm?.length >= 3) {
      this.popupSearchTerm = trimmedTerm;
      this.searchPhamracy(() => {
        if (this.PharmacyNamesList?.length) {
            this.phamrcySearchModel = this._modalService.open(this.patExternPhamracySuggest, {
            backdrop: false,keyboard: false,size: "lg",windowClass: "medium-modal",centered : true });
        } else {
          const manualPharmacy = {
            PharmName: trimmedTerm,
            ServiceLevels: null,
            OrganizationAddress: '',
            OrganizationPrimaryPhoneNumber: ''
          };
          this.selectedPharmacyDetails(manualPharmacy);
        }
      });
    }
  }

  checkService(x) {
        if(typeof x?.ServiceLevels === 'string') {
          return x?.ServiceLevels?.split(',')?.includes('RxTransfer');
        }  else {
          return  x?.ServiceLevels;
        }
  }
  
  searchPhamracy(callback?: Function) {
    const term = this.popupSearchTerm?.trim();
    if (term?.length >= 3) {
      const modelData = this._commonUtil.getOrganizationRequestForPharmSuggest(term);
      if (modelData) {
        this._eRxService.toGetTranferPharListWithServiceAvail(modelData).subscribe((pharmacies) => {
          this.PharmacyNamesList = pharmacies;
          if (callback) callback();
        });
      }
    }
  }
  
  clearInputFiled(){
    this.searchTerm = "";
    this.popupSearchTerm = "";
    this.PharmacyNamesList = null;
  }
    
  getPatientAddress(x) {
    if(x)
    {
      const fullAdrress = this._patientUtil.getPatientAddress({
        address1 :  x?.AddressLine1,
        address2 :   x?.AddressLine2,
        city : x?.CityName,
        state : x?.StateName,
        zipcode : x?.ZipCode,
      });
    return fullAdrress;
    }
  }
  openAddPopUp() {
    this.addPharFG.controls["TransferPharmacies"].reset();
    this.addPharFG.controls["TransferPharmacies"].markAsUntouched();
    this.addPharFG.controls["phone1"].reset();
    this.addPharFG.controls["phone1"].markAsUntouched();
    this.addPharFG.controls["phone2"].reset();
    this.addPharFG.controls["phone2"].markAsUntouched();
    this.addPharFG.controls["Fax"].reset();
    this.addPharFG.controls["Fax"].markAsUntouched();
    this.citySelected = null;
    this.stateSelected = null;
    this.isedit = false;
    this.addPopUp = true;
    this.openTransferPharmacy();
}
openTransferPharmacy() {
  if( this.searchTerm) {
    this.addPharFG.controls["TransferPharmacies"].patchValue({PharmName: this.searchTerm});
  }
  const modalRef = this._modalService.open(TransferPharmacyComponent, {
      centered: true,
      windowClass: "medium-sm-modal-30 modal-md",

  });
  modalRef.componentInstance.PharmacyFG = this.addPharFG;
  modalRef.componentInstance.IsEditMode = this.isedit;
  modalRef.result
      .then(res => {
          if (res.AddValue) {
            this.focusOut = false;
            this.selectedPharmDeatails.PharmId= String(res.AddValue);
            this.selectedPharmDeatails.OrgID= res.AddValue;
            this.editPharResult(this.selectedPharmDeatails?.PharmId);
            this.selectedPharm.emit(this.selectedPharmDeatails);
          }
          if (res.Editvalue) {
              this.editPharResult(this.selectedPharmDeatails?.PharmId);
              this.CloseEditPharmacy.emit(false);
          }
          this.closeCommonPopUp(res.IsPopUpClosed);
      })
      .catch(error => error);
}
closeCommonPopUp(content) {
  this.addPopUp = content;
}

  editPharResult(data) {
    if (data) {
      this.getPharmcyDetails(data);
    }
  }

  addNewPharResult(data) {
    this.newPharId = data;
    this.rxTransferFG.controls["XferPharmIdxId"].patchValue(this.newPharId);
    this.rxTransferFG.controls.XferPharmIdxId.markAsTouched();
    this.getPharmcyDetails(this.newPharId);
  }

  getPharmcyDetails(pharmId) {
    this._rxSer.getPharmacyDetails(pharmId).subscribe((res: any) => {
      this.selectedPharmDeatails = res.TransferPharmacies;
      if (res?.Phone?.length) {
        for (let phoneDetails of res.Phone) {
          if (phoneDetails) {
            if (phoneDetails["PhoneCatId"] === 4) {
              this.selectedPharmDeatails["Fax"] = phoneDetails["Phone"];
            } else {
              if(phoneDetails?.Phone?.length) {
                this.selectedPharmDeatails["Phone"] = phoneDetails["Phone"];
              }
            }
          }
        }
      }
      this.selectedPharm.emit(this.selectedPharmDeatails);
    })
  }
  editPharmacyFromLocalDb() {
    this.addPopUp = false;
    const PharmId  = this.selectedPharmDeatails?.PharmId?.trim()?.length ? this.selectedPharmDeatails?.PharmId.trim() : null;
    if (PharmId) {
      this._rxSer.getPharmacyDetails(PharmId).pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
        if (resp) {
          resp.TransferPharmacies.PharmName = resp?.TransferPharmacies?.PharmName?.trim()
          resp.TransferPharmacies.DEANum = resp?.TransferPharmacies?.DEANum?.trim()
          resp.TransferPharmacies.ZipCode = resp?.TransferPharmacies?.ZipCode?.trim()
          resp.TransferPharmacies.NPINum = resp?.TransferPharmacies?.NPINum?.trim()
          resp.TransferPharmacies.AddressLine1 = resp?.TransferPharmacies?.AddressLine1?.trim()
          this.addPharFG.controls["TransferPharmacies"].patchValue(
            resp["TransferPharmacies"]
          );
          this.addPharFG.controls["Phone"].patchValue(
            resp["Phone"]
          );
          this.pharmcyDet.TransferPharmacy = resp["TransferPharmacies"];
          this.pharmcyDet.Phone = resp["Phone"];
          
          for (const key in this.pharmcyDet) {
            if (key === "Phone") {
              this.generateFA(key, this.pharmcyDet.Phone);
            }
          }
          this.editTransferPharmList();
          this.openTransferPharmacy();
        }
      });
    }
  }

  async editPharmacyAddToLocalDb() {
    this.citySelected = new City();
    this.pharmcyDet.TransferPharmacy = this.selectedPharmDeatails;
    this.pharmcyDet = this.DataResult ? this.DataResult : this.pharmcyDet;
    if (this.pharmcyDet.TransferPharmacy) {
        this.stateSelected = new State();
        if (this.pharmcyDet?.TransferPharmacy?.StateId) {
            this.stateSelected.Id = this.pharmcyDet.TransferPharmacy.StateId;
            this.stateSelected.Name =  this.pharmcyDet.TransferPharmacy.StateName;
        }else {
          const stateData:any =  await this._commonServ.getStatesData(this.pharmcyDet.TransferPharmacy.StateName).toPromise();
          if(stateData && stateData.length) {
            this.stateSelected.Id = stateData[0]?.Id;
            this.stateSelected.Name =  stateData[0]?.Name;
            this.pharmcyDet.TransferPharmacy.StateId =  stateData[0]?.Id;
            this.pharmcyDet.TransferPharmacy.CountryId =  stateData[0]?.CountryId;
          }
        }
        if (this.pharmcyDet?.TransferPharmacy?.CityId) {
            this.citySelected.Id = this.pharmcyDet.TransferPharmacy.CityId;
            this.citySelected.Name =  this.pharmcyDet.TransferPharmacy.CityName;
            this.citySelected.StateId = this.pharmcyDet.TransferPharmacy.StateId;
        } else {
           const cityData :any =  await this._commonServ.getCitiesData(this.pharmcyDet.TransferPharmacy.CityName, this.pharmcyDet.TransferPharmacy.StateId).toPromise();
            if(cityData && cityData.length) {
              this.citySelected.Id = cityData[0]?.Id;
              this.citySelected.Name =  cityData[0]?.Name;
              this.pharmcyDet.TransferPharmacy.CityId =  cityData[0]?.Id;
            }
        }
        this.pharmcyDet.TransferPharmacy.NCPDPID = null;
    }
    for (const key in this.pharmcyDet) {
      if (key) {
        if (key === "TransferPharmacy" && this.pharmcyDet[key]) {
          this.addPharFG.controls["TransferPharmacies"].patchValue(
            this.pharmcyDet[key]
          );
          if(this.pharmcyDet[key]["Phone"]) {
            this.addPharFG.controls["phone1"].patchValue(
            this.pharmcyDet[key]["Phone"]
          );
          }
          if(this.pharmcyDet[key]["Fax"]){
            this.addPharFG.controls["Fax"].patchValue(
            this.pharmcyDet[key]["Fax"]
          );
          }
        }
      }
    }
    this.addPopUp = true;
    this.openTransferPharmacy();
}

  editTransferPharmList() {
    this.isedit = true;
    const transferPharmacy = this.pharmcyDet?.TransferPharmacy;
    const phones = this.pharmcyDet?.Phone || [];

    // Set city and state selections
    if (transferPharmacy) {
      this.citySelected = new City();
      if (transferPharmacy?.CityId) {
        this.citySelected.Id = transferPharmacy.CityId;
        this.citySelected.Name = transferPharmacy.CityName ?? '';
        this.citySelected.StateId = transferPharmacy.StateId ?? null;
      }
      this.stateSelected = new State();
      if (transferPharmacy?.StateId) {
        this.stateSelected.Id = transferPharmacy.StateId;
        this.stateSelected.Name = transferPharmacy.StateName ?? '';
      }
      if (transferPharmacy?.NPINum) {
        transferPharmacy.NPINum = transferPharmacy.NPINum.toString();
      }
      if (this.addPharFG?.controls?.["TransferPharmacies"]) {
        this.addPharFG.controls["TransferPharmacies"].patchValue(transferPharmacy);
      }
    }

    // Patch phone/fax values
    let phone1 = null, phone2 = null, fax = null;
    phones.forEach(phoneDetail => {
      if (!phoneDetail) return;
      const phoneValue = phoneDetail?.Phone.trim()?.length ? phoneDetail.Phone : null;
      if (phoneDetail?.PhoneCatId === 4) {
        fax = phoneValue ?? this.selectedPharmDeatails?.Fax ?? phoneValue;
      } else if (phone1 === null) {
        phone1 = phoneValue ?? this.selectedPharmDeatails?.Phone ?? null;
      } else {
        phone2 = phoneValue ?? null;
      }
    });

    if (this.addPharFG) {
      this.addPharFG.patchValue({
        phone1,
        phone2,
        Fax: fax
      });
    }

    // Ensure city/state are set if pharmcyDet exists
    if (transferPharmacy) {
      this.citySelected = new City();
      this.citySelected.Id = transferPharmacy.CityId ?? null;
      this.citySelected.Name = transferPharmacy.CityName ?? '';
      this.citySelected.StateId = transferPharmacy.StateId ?? null;
      this.stateSelected = new State();
      this.stateSelected.Id = transferPharmacy.StateId ?? null;
      this.stateSelected.Name = transferPharmacy.StateName ?? '';
    }

    this.addPopUp = true;
  }
  generateFA(key: string, values: any[]) {
    if (values) {
      const extraCostFGs = values.map(val => this._fb.group(val));
      const extraCostFormArray = this._fb.array(extraCostFGs);
      this.addPharFG.setControl(key, extraCostFormArray);
    }
  }

}  